export default __webpack_public_path__ + "static/media/editSquare.c3e3ab26.svg";